module.exports = __webpack_public_path__ + "static/media/logo-totalpass.44165e97.svg";